function spaFilter() {

	var $filtersClear = document.querySelector('.filters-clear'),
		$filterBox = document.querySelectorAll('.filter-box'),
		$filterBoxInner = document.querySelectorAll('.filter-box-inner'),
		$treatmentTags = document.querySelectorAll('.treatment-tags'),
		$treatmentTag = document.querySelectorAll('.treatment-tag');

	function slideElements(){
		var $treatmentListHld = $('.treatments-list-hld'),
			$treatmentDescHidden = $('.treatment-desc-hidden'),
			$treatmentCategory = $('.treatments-category'),
			$treatment = $('.treatment');

		$treatmentCategory.each(function(index){
			$this = $(this);
			$this.attr('data-tab-no', index);
		});

		$('.treatment-title').on('click', function(){
			var tabIndex = $(this).parent().filter('[data-tab-no]').attr('data-tab-no'),
				$treatmentListHld = $('.treatments-list-hld'),
				$treatmentCategory = $('.treatments-category');

			$treatmentCategory.removeClass('active');

			$treatment.removeClass('active');
			$treatmentDescHidden.slideUp(400);

			var isActive = false;
			if($treatmentListHld.eq(tabIndex).is('.active')){
				isActive = true;
			}

			$treatmentListHld.removeClass('active');
			$treatmentListHld.slideUp(400);

			if(!isActive){
				$(this).parent().addClass('active');

				$treatmentListHld.eq(tabIndex).addClass('active');
				$treatmentListHld.eq(tabIndex).slideDown(400);
				$treatmentListHld.eq(tabIndex).siblings('.img-hld').find('.title').addClass('active');
			}
		});

		$('.treatment-top').on('click', function(){
			var isActive = false;
			if($(this).parent('.treatment').is('.active')){
				isActive = true;
			}
			$treatment.removeClass('active');
			$treatmentDescHidden.slideUp(400);
			if(!isActive){
				$(this).parent('.treatment').addClass('active');
				$('.treatment-desc-hidden', $(this).parent('.treatment')).slideDown(400);
			}
		});
	};

	function reload(){
		var treatment_tags = [],
			$treatmentsCategory = document.querySelectorAll('.treatments-category'),
			$noTreatments = document.querySelector('.no-treatments'),
			$listingHld = document.getElementById('listing-hld');

		$('.treatment-tag.selected').each(function(index,el){
			treatment_tags.push($(el).attr('data-tag-id'));
		});

		$('.loading').fadeIn(300);

		$.ajax({
			type: "POST",
			url: window.location.href,
			data: { treatment_tags: treatment_tags }
		}).done(function(ret) {
			$('#listing-hld').html($(ret).find('#listing-hld').html());
			
			slideElements();

			if(document.querySelectorAll('.treatments-category').length < 1){
				$listingHld.classList.add('no-items');
				$noTreatments.classList.add('active');
			} else {
				$listingHld.classList.remove('no-items');
				$noTreatments.classList.remove('active');
			}
			
			$('.loading').fadeOut(300);

		});
	};

	$('.treatments-list-hld').slideUp();

	/* Open subfilters on click */
	for(var i=0; i < $filterBoxInner.length; i++) {
		$filterBoxInner[i].addEventListener('click', function(e){
			var index = this.getAttribute('data-treatment');
			
			this.classList.toggle('active');

			for(var i=0; i < $filterBox.length; i++) {
				$filterBox[i].classList.remove('active');
				$treatmentTags[i].classList.remove('active');
			}

			$('.treatment-subfilters .treatment-tags').filter('[data-treatment='+ index + ']').addClass('active');

			$('.treatment-subfilters').eq(index).slideToggle();
		});
	}

	/* Select treatment from subfilters and ajax load listing */
	for(var i=0; i < $treatmentTag.length; i++) {
		$treatmentTag[i].addEventListener('click', function(){
			var treatment = this.parentNode.getAttribute('data-treatment'),
				$siblings = $(this).siblings('.treatment-tag'),
				treatmentName = $(this).text(),
				$selectedTreatment = $('.filter-box-inner').filter('[data-treatment=' + treatment + ']').find('.selected-treatment');

			$selectedTreatment.html(treatmentName);
			$siblings.removeClass('selected');
			this.classList.add('selected');

			reload();
		});
	}

	/* Clear filters */

	$filtersClear.addEventListener('click', function(e){
		e.preventDefault();

		for(var i=0; i < $filterBoxInner.length; i++) {
			$filterBoxInner[i].classList.remove('active');
			$treatmentTags[i].classList.remove('active');
		}

		for(var i=0; i < $treatmentTag.length; i++) {
			$treatmentTag[i].classList.remove('selected');
		}

		$('.treatment-subfilters').slideUp(300);

		reload();
	});

	slideElements();
	
};

module.exports = spaFilter;